import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_EVENTS, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_EVENT,
  UPDATE_EVENT,
  DELETE_EVENT,
  GET_EVENTS_BY_CLIENT_ID
 } from "./actionTypes";
import {
  getEventsSuccess,
  getEventsFail,
  addEventSuccess,
  addEventFail,
  updateEventSuccess,
  updateEventFail,
  deleteEventSuccess,
  deleteEventFail,
  // getEventProfileSuccess,
  // getEventProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import {
  // getEventProfile,
  addNewEvent_1,
  updateEvent_1,
  deleteEvent_1,
  getEvents_1,
  getEvents_By_Id_1,
} from "../../helpers/backend_helper"

function* fetchEventsByClientId({
  payload: { is_active, client_id, offset, page_size },
}) {
  try {
    const response = yield call(getEvents_By_Id_1, { is_active, client_id,offset, page_size })
    yield put(getEventsSuccess(response))
  } catch (error) {
    yield put(getEventsFail(error))
  }
}

function* fetchEvents({ payload: { is_active, offset, page_size } }) {
  try {
    const response = yield call(getEvents_1, { is_active,offset, page_size })
    yield put(getEventsSuccess(response))
  } catch (error) {
    yield put(getEventsFail(error))
  }
}


function* onUpdateEvent({ payload: { event, history } }) {
  try {
   let response = yield call(updateEvent_1, event);
  //  if(response.file_src || event.removeImage) event.image = response.file_src
    yield put(updateEventSuccess(event));
    history && history.push("/events")
  } catch (error) {
    yield put(updateEventFail(error));
  }
}

function* onDeleteEvent({ payload: event }) {
  try {
     yield call(deleteEvent_1, event);
    yield put(deleteEventSuccess(event));
  } catch (error) {
    yield put(deleteEventFail(error));
  }
}

function* onAddNewEvent({ payload: { event,history }}) {
  try {
    let response = yield call(addNewEvent_1, event)
    yield put(addEventSuccess(response.data))
    history.push("/events")
  } catch (error) {
    yield put(addEventFail(error))
  }
}


// function* fetchEventProfile() {
//   try {
//     const response = yield call(getEventProfile);
//     yield put(getEventProfileSuccess(response));
//   } catch (error) {
//     yield put(getEventProfileFail(error));
//   }
// }

function* eventsSaga() {
  yield takeEvery(GET_EVENTS_BY_CLIENT_ID, fetchEventsByClientId);
  yield takeEvery(GET_EVENTS, fetchEvents);
  yield takeEvery(ADD_NEW_EVENT, onAddNewEvent);
  yield takeEvery(UPDATE_EVENT, onUpdateEvent);
  yield takeEvery(DELETE_EVENT, onDeleteEvent);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchEventProfile);
}

export default eventsSaga;
